import styled from "styled-components";
import { FONTS, SPACING } from "../../../utils/constants";

export const ErrorPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  margin-top: ${SPACING.md}px;
  padding: ${SPACING.md}px;
  border-radius: 12px;
  background: var(--color-error-background);
  border: 1px solid var(--color-error-border);
`;

export const ErrorPanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.sm}px;
  font-family: ${FONTS.serif};
  font-size: var(--text-md);
  font-weight: 700;
  line-height: 1.35;
  color: var(--color-error);

  svg {
    flex-shrink: 0;
    font-size: var(--text-xl);
    margin-top: ${SPACING.xxs}px;
  }
`;
